import { useContactManagementTranslation } from '../../../../ui/hooks';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import emptyContentImageSmall from '@juvare/common-web-ui/assets/emptyContentImageSmall.svg';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
export const NoFilterContent = ({ loading, error, }) => {
    const { t } = useContactManagementTranslation();
    return (React.createElement(React.Fragment, null,
        loading && error == null && (React.createElement(Box, { sx: {
                py: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement(CircularProgress, { size: 54 }))),
        !loading && error == null && (React.createElement(Box, { sx: {
                py: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement("img", { src: emptyContentImageSmall, alt: '' }),
            React.createElement(Typography, { variant: 'subtitle1' }, t('panels.userDirectory.noFilter')))),
        error != null && (React.createElement(Box, { sx: {
                py: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement(PartialError, { error: error })))));
};
